import { Box, IconButton, Tooltip } from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { changeOrderColumns } from "./columns";
import { lightTable } from "../../../../../styles/muiProps";
import { useParams } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import { secondAxios } from "../../../../../api/axios";
import { updateCO } from "./api";

export default function ChangeOrderTable({ coTableData }) {
  const { plantId } = useParams();

  const [tableData, setTableData] = useState([]);
  const [fabData, setFabData] = useState([]);

  async function getCOs() {
    const fabricationData = fabData || [];
    console.log("tracking cost:", coTableData);
    const data = coTableData?.map((co) => {
      const currentDrawing = co.allDrawingsRevs.find(
        (d) => d.id === co.drawingId,
      );
      const previousDrawing = co.allDrawingsRevs?.find(
        (d) => Number(d.revision) === Number(currentDrawing.revision) - 1,
      );

      const materialsItems = co.materials?.map((m) => m.material.item);

      const previousMaterials =
        previousDrawing?.materials?.filter((pm) =>
          materialsItems?.includes(pm.item),
        ) || [];

      const est_bomTaggedMaterials =
        co.materials?.map((m) => m.tagNumbers || m.taggedMaterial?.tagNumber) ||
        [];
      const est_bulkMaterials =
        previousMaterials?.map(
          (m) =>
            `${m?.description || ""} - ${m?.length !== "-" ? m?.length + " Ft. - " : ""} ${m?.quantity || ""}`,
        ) || [];

      const actual_bomTaggedMaterials =
        co.materials?.map((m) => m.tagNumbers || m.taggedMaterial?.tagNumber) ||
        [];
      const actual_bomBulkMaterials =
        co.materials?.map(
          (m) =>
            `${m?.material?.description || ""} - ${m?.material?.length !== "-" ? m?.material?.length + " Ft. - " : ""} ${m?.material?.quantity || ""}`,
        ) || [];

      const isTagged =
        co.materials?.[0]?.tagNumbers ||
        co.materials?.[0]?.taggedMaterial?.tagNumber;

      const est_bom = isTagged ? est_bomTaggedMaterials : est_bulkMaterials;
      const actual_bom = isTagged
        ? actual_bomTaggedMaterials
        : actual_bomBulkMaterials;

      const materialsFabHours = co.materials?.map((m) => {
        return (
          fabricationData.find(
            (f) => f.materialDescription === m.material?.description,
          )?.actualhours || 0
        );
      });
      const actual_manhours =
        materialsFabHours?.reduce((a, b) => a + b, 0) || 0;

      let actual_materialsCost = 0;

      currentDrawing?.materials?.forEach((m) => {
        console.log("row", m);
        const cost = m?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost;
        const quantity = m?.mrqMaterials?.[0]?.procuredQty || 0;

        // console.log("cost", m);
        if (cost && quantity) {
          // console.log("m", m);
          actual_materialsCost += Number(cost) * Number(quantity);
        }
      });

      const actual_totalCost = actual_materialsCost || 0;

      const est_totalCost =
        Number(co.estMaterialCost) + Number(co.estOtherCost) || 0;

      const profit = est_totalCost - actual_totalCost;

      return {
        ...co,
        actual_bom,
        actual_manhours,
        actual_materialsCost: actual_materialsCost / 2,
        actual_totalCost: actual_totalCost / 2,

        est_bom,
        est_totalCost,

        profit,
      };
    });

    // console.log("data co:", data);
    setTableData(data);
  }

  useEffect(() => {
    getCOs();
  }, [coTableData, fabData]);

  const getFabData = async () => {
    const fabRes = await secondAxios.get(`/fabrication/plant/${plantId}`);
    setFabData(fabRes.data);
  };

  useEffect(() => {
    getFabData();
  }, []);

  const cols = useMemo(
    () =>
      changeOrderColumns({
        user: null,
        tableData,
        setTableData,
        fabData,
      }),
    [tableData],
  );

  // console.log("tableData", tableData?.[0]);
  const table = useMaterialReactTable({
    data: tableData,
    columns: cols,
    ...lightTable,

    enableEditing: true,
    editDisplayMode: "row",
    enableRowActions: true,
    positionActionsColumn: "last",

    // show Edit action per row
    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: 1 }}>
        <Tooltip title="Edit Est. Data + Responsible User">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    // commit ONLY allowed fields on save
    onEditingRowSave: async ({ row, values, table }) => {
      setTableData((prev) => {
        const next = [...prev];
        const oldRow = next[row.index];

        const editedKeys = [
          "estManhours",
          "estMaterialCost",
          "estOtherCost",
          "responsible",
        ];

        const editedData = Object.fromEntries(
          editedKeys.map((key) => [key, oldRow[key]]),
        );
        console.log("editedData", { ...editedData, id: oldRow.id });

        updateCO(oldRow.id, editedData);
        return next;
      });

      table.setEditingRow(null);
    },
  });

  return <MaterialReactTable table={table} />;
}
